import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modalTitle" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "decorateModalTitle" }, null, -1)
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modalTitle), 1),
    _renderSlot(_ctx.$slots, "title"),
    _renderSlot(_ctx.$slots, "default")
  ]))
}